'use strict';

import type { UserSmsThread } from '../../Entities/User/UserSmsThread';
import { EntityCollection } from '../EntityCollection';

export class UserSmsThreadCollection extends EntityCollection<UserSmsThread> {}
